export class PageableDefault {
  page: number | null;
  size: number | null;
  sort: string | null;
  direction: "ASC" | "DESC" | null;

  constructor(page?: number, size?: number, sort?: string, direction?: "ASC" | "DESC") {
    this.page = typeof page == "undefined" ? 0 : page;
    this.size = size ? size : null;
    this.sort = sort ? sort : null;
    this.direction = direction ? direction : null;
  }
}
